import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TreatmentTable from "./TreatmentTable.js";
import TreatmentTableMobile from "./TreatmentTableMobile.js";
import Container from "@material-ui/core/Container";
import { Button, Typography, Grid } from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import API from "../../actions";

const columns = [
    { id: "name", label: "Navn på behandling", align: "left", maxWidth: "100%", type: "text" },
    { id: "price", label: "Pris", align: "center", type: "number", format: "dkk", maxWidth: "90px" },
    { id: "duration", label: "Varighed", align: "center", type: "time", format: "min", maxWidth: "90px" },
    { id: "pause", label: "Pause", align: "center", type: "time", format: "min", maxWidth: "80px" },
    { id: "slet", label: "Slet", align: "center", maxWidth: "40px" }
];

export default props => {
    props.setLocationName();
    const [treatments, setTreatments] = useState([]);
    const [width, setWidth] = useState(window.innerWidth);
    const therapist = useSelector(state => state.data.therapist);

    useEffect(() => {
        (async () => {
            setTreatments(await API.getTreatmentsFromTherapist(therapist.id));
        })();
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [therapist]);

    const tableProps = {
        columns: columns,
        therapist: therapist,
        treatments: treatments,
        saveTreatment: async (list, i) => {
            await API.setTreatment(list[i]);
            setTreatments(list);
        },
        deleteTreatment: async value => {
            await API.deleteTreatment(value);
            setTreatments(await API.getTreatmentsFromTherapist(therapist.id));
        }
    };

    return (
        <Container maxWidth="lg">
            <Grid
                container
                spacing={0}
                style={{
                    padding: "5px 10px 10px 10px",
                    borderRadius: "5px"
                }}>
                <Grid item sm={6} style={{ width: "100%" }}>
                    <Typography variant="h6" style={{ margin: "30px 0 20px 0" }}>
                        {therapist.nameFirst} {therapist.nameLast}
                    </Typography>
                </Grid>
                <Grid item sm={6} style={{ width: "100%" }}>
                    <Button
                        onClick={async () => {
                            await API.addTreatment({ name: " ", price: null, duration: null, pause: null });
                            setTreatments(await API.getTreatmentsFromTherapist(therapist.id));
                        }}
                        style={{
                            margin: "30px 0 20px 0",
                            backgroundColor: "#343434",
                            color: "#fff",
                            float: "right"
                        }}
                        variant="contained"
                        startIcon={<AddCircleIcon />}>
                        Ny behandling
                    </Button>
                </Grid>
            </Grid>
            {width > 800 ? <TreatmentTable {...tableProps} /> : <TreatmentTableMobile {...tableProps} />}
        </Container>
    );
};
